/* 
* This file is auto-generated by Graphweaver. 
* Please do not edit it directly.
*/
import * as Types from '../../../../backend/src/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetUserCouncilChooserQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetUserCouncilChooserQuery = { __typename?: 'Query', user?: { __typename?: 'User', isCouncilStaffOf?: Array<{ __typename?: 'Council', id: string, name: string }> | null } | null };


export const GetUserCouncilChooserDocument = gql`
    query GetUserCouncilChooser($id: ID!) {
  user(id: $id) {
    isCouncilStaffOf {
      id
      name
    }
  }
}
    `;

/**
 * __useGetUserCouncilChooserQuery__
 *
 * To run a query within a React component, call `useGetUserCouncilChooserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserCouncilChooserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserCouncilChooserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserCouncilChooserQuery(baseOptions: Apollo.QueryHookOptions<GetUserCouncilChooserQuery, GetUserCouncilChooserQueryVariables> & ({ variables: GetUserCouncilChooserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserCouncilChooserQuery, GetUserCouncilChooserQueryVariables>(GetUserCouncilChooserDocument, options);
      }
export function useGetUserCouncilChooserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserCouncilChooserQuery, GetUserCouncilChooserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserCouncilChooserQuery, GetUserCouncilChooserQueryVariables>(GetUserCouncilChooserDocument, options);
        }
export function useGetUserCouncilChooserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserCouncilChooserQuery, GetUserCouncilChooserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserCouncilChooserQuery, GetUserCouncilChooserQueryVariables>(GetUserCouncilChooserDocument, options);
        }
export type GetUserCouncilChooserQueryHookResult = ReturnType<typeof useGetUserCouncilChooserQuery>;
export type GetUserCouncilChooserLazyQueryHookResult = ReturnType<typeof useGetUserCouncilChooserLazyQuery>;
export type GetUserCouncilChooserSuspenseQueryHookResult = ReturnType<typeof useGetUserCouncilChooserSuspenseQuery>;
export type GetUserCouncilChooserQueryResult = Apollo.QueryResult<GetUserCouncilChooserQuery, GetUserCouncilChooserQueryVariables>;